import { styled } from "@mui/material";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";
import Typography from "@mui/material/Typography";
import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import BreadCrumbs from "../../../Utils/Common/Breadcrumb";
import { AutocompleteStyle } from "../../../Utils/MuiStyles/AutocompleteStyles";
import OrderList from "./OrderList";
import useLang from "Shared/hooks/useLanguage";

const TabSelected = styled(Tab)(AutocompleteStyle());

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`oncology-manage-order-tabpanel-${index}`}
      aria-labelledby={`oncology-manage-order-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 0 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `oncology-manage-order-tab-${index}`,
    "aria-controls": `oncology-manage-order-tabpanel-${index}`,
  };
}

const ManageOrderOncology: React.FC = () => {
  const { t } = useLang();
  const location = useLocation();
  const { shipped } = location.state || {};
  const [value, setValue] = useState(0);

  const handleChange = (_event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
  };

  useEffect(() => {
    if (shipped === "shipped") {
      setValue(1);
    }
  }, [shipped]);

  return (
    <>
      <div className="app-toolbar py-2 py-lg-3">
        <div className="app-container container-fluid d-flex flex-wrap gap-4 justify-content-center justify-content-sm-between align-items-center">
          <BreadCrumbs />
        </div>
      </div>
      <div className="d-flex flex-column flex-column-fluid">
        <div className="app-content flex-column-fluid">
          <div className="app-container container-fluid">
            <Tabs
              value={value}
              onChange={handleChange}
              TabIndicatorProps={{ style: { background: "transparent" } }}
              className="min-h-auto"
              variant="scrollable"
              scrollButtons="auto"
              allowScrollButtonsMobile
              sx={{
                "& .MuiTabs-scrollButtons": {
                  width: 0,
                  transition: "width 0.7s ease",
                  "&:not(.Mui-disabled)": {
                    width: "48px",
                  },
                },
              }}
            >
              <TabSelected
                label={t("New Orders")}
                {...a11yProps(0)}
                className="fw-bold text-capitalize"
                id="OncologyNewOrder"
              />
              <TabSelected
                label={t("Shipped")}
                {...a11yProps(1)}
                className="fw-bold text-capitalize"
                id="OncologyShipped"
              />
              <TabSelected
                label={t("Rejected")}
                {...a11yProps(2)}
                className="fw-bold text-capitalize"
                id="OncologyRejected"
              />
            </Tabs>
            <div className="card rounded-top-0 shadow-none">
              <div className="card-body py-2">
                <TabPanel value={value} index={0}>
                  <OrderList mode="new" />
                </TabPanel>
                <TabPanel value={value} index={1}>
                  <OrderList mode="shipped" />
                </TabPanel>
                <TabPanel value={value} index={2}>
                  <OrderList mode="rejected" />
                </TabPanel>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageOrderOncology;
